import { getBriefRecipients } from '@disco/api/briefs'

import type { BriefRecipientContact } from 'types/brief'

import { api } from './index'

export const briefsApi = api
  .enhanceEndpoints({ addTagTypes: ['BriefAssignedRecipients'] })
  .injectEndpoints({
    endpoints: build => ({
      getAssignedBriefRecipients: build.query<BriefRecipientContact[], number>({
        queryFn: async briefId => {
          try {
            const data = await getBriefRecipients(briefId, {
              type: 'assigned',
            })
            return { data }
          } catch (error) {
            return { error }
          }
        },
        providesTags: (_result, _error, briefId) => [
          { type: 'BriefAssignedRecipients', id: briefId },
        ],
      }),
    }),
  })

export const { useGetAssignedBriefRecipientsQuery } = briefsApi
